<template>
	<div class="bg-gray" v-if="!loading">
		<BaseNav></BaseNav>
		<a-spin :spinning="loading">
			<div class="content">
				<div class="head-bg" :style="`background: url(${headBg});backgroundSize:cover;`"></div>
			</div>
			<div class="container">
				<!-- 党建动态 -->
				<div class="party-active flex justify-between">
					<newsSwiper :list="newsSwiper" :type="1" width="534px" height="382px" radius="8px"></newsSwiper>
					<div class="list">
						<div class="flex justify-between align-center title">
							<div class="flex align-center">
								<div class="line"></div>
								<div class="color-1a margin-left-5 font-24"><span class="text-red">{{newsList[0].newsType.newsType || ''}}</span>{{newsList[0].newsType.newsTSecType || ''}}
								</div>
							</div>
							<router-link tag="a" 
								:to="{path:'/news/list',query:{homeMenuFirstId:newsList[0].newsType.homeMenuFirstId,menuPosition:menuPosition,newsType:newsList[0].newsType.id}}"><img
									@mouseleave="moreLeave" @mouseenter="moreEnter" :src="moreIcon"
									alt=""></router-link>
						</div>
						<!-- 列表 -->
						<div v-for="(item,index) in newsList[0].pageList.records"
							v-if="index==0 && newsList[0].pageList.records.length>=0"
							class="item active border-bottom-dott padding-top-15 padding-bottom-15 hover-item">
							<div class=" color-1a font-18 " style="display: flex;justify-content: space-between;"><router-link class="color-1a overflow-eli"
									:to="{path:'/news/info',query:{newsId:item.id}}" tag="a" style="display: block;width: 80%;"> ·
									{{item.newsTitle}}</router-link><span style="float: right;font-size: 16px;"
									class="time color-999">{{item.releaseTime}}</span></div>
							<div class="desc margin-left-15 padding-top-15">{{item.content}}</div>
							<!-- <div class="time color-999 padding-top-15">{{item.releaseTime}}</div> -->
						</div>
						<div v-for="(item,index) in newsList[0].pageList.records"
							v-if="index>0 && index<5 && newsList[0].pageList.records.length>=0"
							class="item border-bottom-dott padding-top-15 padding-bottom-15 flex justify-between align-center hover-item">
							<div class="color-1a font-16 overflow-eli w-300"><router-link class="hover-a" tag="a"
									:to="{path:'/news/info',query:{newsId:item.id}}"> · {{item.newsTitle}}</router-link>
							</div>
							<div class="time color-999">{{item.releaseTime}}</div>
						</div>
						<div v-if="newsList[0].pageList.records.length<=0" class="padding-top-15">
							<a-empty style="padding:50px;" description="暂无数据" />
						</div>
					</div>
				</div>
				<!-- 党建动态模板结束 -->

				<!-- 理论学习 -->
				<div class="flex justify-between flex-wrap">
					<div class="study-box margin-bottom-15" v-for="(list,listIndex) in newsList"
						v-if="listIndex>0 && listIndex < newsList.length-1">
						<div class="flex justify-between align-center title">
							<div class="flex align-center">
								<div class="line"></div>
								<div class="color-1a margin-left-5 font-24"><span
										class="text-red">{{list.newsType.newsType}}</span>{{list.newsType.newsTSecType}}
								</div>
							</div>
							<router-link tag="a"
								:to="{path:'/news/list',query:{homeMenuFirstId:list.newsType.homeMenuFirstId,menuPosition:menuPosition,newsType:list.newsType.id}}"><img
									@mouseleave="moreLeave" @mouseenter="moreEnter" :src="moreIcon"
									alt=""></router-link>
						</div>
						<div v-for="(item,index) in list.pageList.records"
							v-if="index<8  && list.pageList.records.length>=0"
							class="item border-bottom-dott padding-tb-18 flex justify-between align-center hover-item">
							<div class=" color-1a font-16 line-1 w-300"><span>·</span><router-link class="hover-a"
									tag="a"
									:to="{path:'/news/info',query:{newsId:item.id}}">{{item.newsTitle}}</router-link>
							</div>
							<div class="time w-90 color-999">{{item.releaseTime}}</div>
						</div>
						<div v-if="list.pageList.records.length<=0" class="padding-top-15">
							<a-empty style="padding:50px;" description="暂无数据" />
						</div>
					</div>
				</div>
				<!-- 理论学习结束 -->

				<!-- 基层堡垒 -->
				<!-- <div class="basic-box fr">
				<div class="flex justify-between align-center title">
					<div class="flex align-center">
						<div class="line"></div><div class="color-1a margin-left-5 font-28"><span class="text-red">{{newsList[2].newsType.newsType}}</span>{{newsList[2].newsType.newsTSecType}}</div>
					</div>
					<router-link tag="a" :to="{path:'/news/list',query:{homeMenuFirstId:newsList[2].newsType.homeMenuFirstId,menuPosition:menuPosition,newsType:newsList[2].newsType.id}}"><img @mouseleave="moreLeave" @mouseenter="moreEnter" :src="moreIcon" alt=""></router-link>
				</div>
				<div v-for="(item,index) in newsList[2].pageList.records" v-if="index==0 && newsList[2].pageList.records.length>=0" class="item border-bottom-dott padding-top-15 padding-bottom-15 flex justify-between hover-item">
					<img :src="$api.baseUrl+$api.imgPath+item.pcImageUrl" width="200" class="cover" alt="">
					<div class="w-395">
						<div class="font-22 overflow-eli"><router-link :to="{path:'/news/info',query:{newsId:item.id}}" tag="a" class="color-1a">{{item.newsTitle}}</router-link></div>
						<div class="desc color-999 padding-top-10">{{item.content}}</div>
						<div class="time padding-top-15 color-999">{{item.releaseTime}}</div>
					</div>
				</div>
				<div v-for="(item,index) in newsList[2].pageList.records" v-if="index>0 && index<5 && newsList[2].pageList.records.length>=0" class="item border-bottom-dott padding-top-15 padding-bottom-15 flex justify-between align-center hover-item">
					<div class="w-300 color-1a font-16 overflow-eli"><router-link class="hover-a" tag="a" :to="{path:'/news/info',query:{newsId:item.id}}">{{item.newsTitle}}</router-link></div>
					<div class="time color-999">{{item.releaseTime}}</div>
				</div>
				<div v-if="newsList[2].pageList.records.length<=0" class="padding-top-15">
					<a-empty style="padding:50px;" description="暂无数据" />
				</div>
			</div> -->
				<!-- 基层堡垒结束 -->
				<div class="clear"></div>
				<!-- 专题活动 -->
				<div class="spical-box">
					<div class="flex justify-between align-center title">
						<div class="flex align-center">
							<div class="line"></div>
							<div class="color-1a margin-left-5 font-24"><span
									class="text-red">{{newsList[newsList.length-1].newsType.newsType}}</span>{{newsList[newsList.length-1].newsType.newsTSecType}}
							</div>
						</div>
						<router-link tag="a"
							:to="{path:'/news/list',query:{homeMenuFirstId:newsList[newsList.length-1].newsType.homeMenuFirstId,menuPosition:menuPosition,newsType:newsList[newsList.length-1].newsType.id}}"><img
								@mouseleave="moreLeave" @mouseenter="moreEnter" :src="moreIcon" alt=""></router-link>
					</div>
					<div class="padding-top-15" style="overflow: hidden;">
						<vue-seamless-scroll :data="newsList[newsList.length-1].pageList.records"
							:class-option="seamlessScrollOption" class="scroll_box">
							<div class="flex justify-between">
								<div class="item" v-for="(item,index) in newsList[newsList.length-1].pageList.records"
									v-if=" newsList[newsList.length-1].pageList.records.length>=0">
									<router-link :to="{path:'/news/info',query:{newsId:item.id}}" tag="a"><img
											width="428" height="260" class="radius-8 cover"
											:src="$api.baseUrl+$api.imgPath+item.pcImageUrl" alt=""></router-link>
									<div class="item-title">{{item.newsTitle}}</div>
								</div>
							</div>
						</vue-seamless-scroll>

						<div v-if="newsList[newsList.length-1].pageList.records.length<=0" class="padding-top-15">
							<a-empty style="padding:50px;" description="暂无数据" />
						</div>
					</div>
				</div>
				<!-- 专题活动结束 -->
			</div>
		</a-spin>
		<BaseFooter></BaseFooter>
	</div>
</template>

<script>
	import BaseNav from "@/components/BaseNavigation"
	import BaseFooter from "@/components/BaseFooter"
	import newsSwiper from "@/components/NewsSwiper"
	import vueSeamlessScroll from 'vue-seamless-scroll'
	export default {
		components: {
			BaseNav,
			BaseFooter,
			newsSwiper,
			vueSeamlessScroll
		},
		data() {
			return {
				menuPosition: "",
				headBg: "",
				newsSwiper: [],
				newsList: [],
				loading: true,
				moreIcon: require("../../assets/more.png"),
				moreIconActive: require("../../assets/more_active.png"),
			}
		},
		created() {
			document.title = "雄安股权交易所-党的建设";
			this.menuPosition = "1482178158344089602";
			this.getRecommendNews();
			this.getNews();
			this.getHeadBanner();
		},
		computed: {
			seamlessScrollOption() {
				return {
					step: 0.5, // 数值越大速度滚动越快
					limitMoveNum: 1, // 开始无缝滚动的数据量 this.dataList.length
					hoverStop: true, // 是否开启鼠标悬停stop
					direction: 2, // 0向下 1向上 2向左 3向右
					openWatch: true, // 开启数据实时监控刷新dom
					singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
					singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
					waitTime: 3000, // 单步运动停止的时间(默认值1000ms)
				};
			}
		},
		methods: {
			getHeadBanner() {
				this.$request({
					url: this.$api.public.getBanner,
					data: {
						menuPosition: this.menuPosition,
						type: 1
					}
				}).then((res) => {
					this.headBg = this.$api.baseUrl + this.$api.imgPath + res.data.result[0].pcImageUrl;
				})
			},
			getRecommendNews() {
				this.$request({
					url: this.$api.news.getRecommendNews,
					data: {
						menuId: this.menuPosition
					},
				}).then((res) => {
					this.newsSwiper = res.data.result;
					console.log(this.newsSwiper);
					
				})
			},
			getNews() {
				this.$request({
					url: this.$api.news.getNewsType,
					data: {
						menuId: this.menuPosition,
						type: 1
					},
				}).then((res) => {
					this.newsList = res.data.result;
					this.loading = false;
				})
			},
			moreEnter(e) {
				e.target.src = this.moreIconActive;
			},
			moreLeave(e) {
				e.target.src = this.moreIcon;
			}
		}
	}
</script>

<style scoped="scoped">
	.study-box {
		width: 590px;
		min-height: 410px;
		background: #FFFFFF;
		opacity: 1;
		border-radius: 8px;
		padding: 20px;
	}

	.scroll_box {
		width: 100%;
	}

	.spical-box {
		width: 1200px;
		background: #FFFFFF;
		opacity: 1;
		border-radius: 8px;
		padding: 20px;
		margin-bottom: 24px;
	}

	.spical-box .item {
		width: 360px;
		height: 250px;
		margin-left: 15px;
		margin-right: 15px;
		position: relative;
	}

	.spical-box .item img {
		width: 100%;
		height: 250px;
		object-fit: cover;
		transition: all 0.3s;
	}

	.spical-box .item .item-title {
		position: absolute;
		width: 100%;
		bottom: 0;
		padding: 10px;
		border-bottom-left-radius: 8px;
		border-bottom-right-radius: 8px;
		background-color: rgba(0, 0, 0, 0.6);
		color: white;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		transition: linear 0.2s;
	}

	.spical-box .item:hover img {
		filter: brightness(50%);
	}

	.spical-box .item:hover .item-title {
		color: #1A1A1A;
		width: 90%;
		left: 5%;
		bottom: 15px;
		border-radius: 8px;
		overflow: hidden;
		white-space: pre-wrap;
		text-overflow: ellipsis;
		background-color: white;
	}

	.basic-box {
		width: 590px;
		min-height: 500px;
		background: #FFFFFF;
		opacity: 1;
		border-radius: 8px;
		padding: 30px;
	}

	.study-box .title {
		padding-bottom: 15px;
		border-bottom: 1px solid #D9D9D9;
	}

	.basic-box .title {
		padding-bottom: 15px;
		border-bottom: 1px solid #D9D9D9;
	}

	.spical-box .title {
		padding-bottom: 15px;
		border-bottom: 1px solid #D9D9D9;
	}

	.content {
		/* position: relative; */
	}

	.content .container {
		z-index: 1;
	}

	body {
		background-color: #F6F7FC;
	}

	.head-bg {
		width: 100%;
		height: 496px;
	}

	.party-active {
		width: 100%;
		/* height: 540px; */
		background: #FFFFFF;
		border-radius: 8px;
		padding: 20px;
		margin-top: -150px;
		/* margin-top: 40px; */
		z-index: 999;
		margin-bottom: 16px;
	}

	.party-active .list {
		width: 600px;
	}

	.party-active .list .title {
		padding-bottom: 15px;
		border-bottom: 1px solid #D9D9D9;
	}

	.bg-gray {
		background: #F6F7FC;
	}

	.text-red {
		color: #FD2F35;
	}

	.line {
		width: 4px;
		height: 24px;
		background: linear-gradient(180deg, #FF9943 0%, #FD2F35 100%);
		opacity: 1;
		border-radius: 0px;
	}

	.hover-item:hover {
		border-bottom: 1px dotted #13B8EE;
	}

	.hover-item:hover a {
		color: #13B8EE;
	}

	.padding-bottom-15 {
		padding-bottom: 15px;
	}

	.padding-top-15 {
		padding-top: 15px;
	}

	.padding-top-13 {
		padding-top: 13px;
	}

	.border-bottom-dott {
		border-bottom: 1px dotted #D9D9D9;
	}

	.hover-a {
		color: #1A1A1A;
	}

	.hover-a:hover {
		color: #13B8EE;
	}

	.fl {
		float: left;
	}

	.fr {
		float: right;
	}

	.clear {
		clear: both;
	}
</style>


// WEBPACK FOOTER //
// src/pages/party/party.vue